var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.tiptapEditor,{staticClass:"tiptap-message-field",attrs:{"value":_setup.props.value,"disabled":_setup.props.disabled ?? false,"paragraphs-on-return":_setup.props.paragraphsOnReturn ?? false},on:{"input":c => { _setup.emit('input', c) },"ready":function($event){return _setup.emit('ready', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }